// extracted by mini-css-extract-plugin
export default {"wrapper":"Text_wrapper__EwMl1","colorDefault":"Text_colorDefault__jO4DH"};